import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorHandlingService } from '../../../services/utils/error-handling.service';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-qr-integration',
  templateUrl: './qr-integration.component.html',
  styleUrls: ['./qr-integration.component.scss'],
})
export class QrIntegrationComponent implements OnInit {
  @Output() goBackPressed = new EventEmitter<void>();
  commerceCheckoutUrl = environment.commerceCheckoutUrl;

  constructor(private dialog: MatDialog, private errorhandling: ErrorHandlingService) {}

  ngOnInit(): void {}

  openRequestQrDialog(): void {
    this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
      panelClass: 'general-modal-container',
      data: {
        title: 'Solicitar cartón QR',
        content: `
          Para pedir el envío del paquete QR físico para tu local envianos un mail a: <a href="mailto:info@tiendacrypto.com">info@tiendacrypto.com</a>
        `,
        acceptLabel: 'OK',
      },
    });
  }

  goBack(): void {
    this.goBackPressed.emit();
  }

  openChangePasswordDialog(): void {
    this.dialog
      .open(ChangePasswordDialogComponent, {
        panelClass: 'modal-container',
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.errorHandler(res);
        }
      });
  }

  errorHandler(error: HttpErrorResponse) {
    this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
      panelClass: 'modal-container',
      data: {
        ...this.errorhandling.handleError(error),
        isError: true,
      },
    });
  }
}
